'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/panel-white-aside.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _reduxWindow = require('redux-window');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _panelWhite = require('./panel-white');
var _panelWhite2 = _interopRequireDefault(_panelWhite);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
PanelWhiteAside.propTypes = {
  img: _propTypes.node.isRequired,
  alt: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired,
  width: _propTypes.number.isRequired,
  theme: _propTypes.object.isRequired
};
function PanelWhiteAside(props) {
  var children = props.children,
    img = props.img,
    width = props.width,
    alt = props.alt,
    rest = _objectWithoutProperties(props, ['children', 'img', 'width', 'alt']);
  var showImg = width >= props.theme.breakpoint_sm;
  return _react2.default.createElement(_panelWhite2.default, Object.assign({}, rest, {
    noPadding: showImg,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22
    },
    __self: this
  }), showImg ? _react2.default.createElement(_glamorous2.default.Div, {
    css: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    },
    __self: this
  }, _react2.default.createElement(_glamorous2.default.Main, {
    css: {
      width: '63%',
      padding: props.theme.space_md
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }, children), _react2.default.createElement(_glamorous2.default.Aside, {
    css: _defineProperty({
      width: '37%',
      backgroundColor: props.theme.colorSecondary
    }, (0, _themes.atLeast)(props.theme.breakpoint_sm), {
      padding: '100px ' + props.theme.space_sm
    }),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38
    },
    __self: this
  }, _react2.default.createElement('img', {
    src: img,
    alt: alt,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47
    },
    __self: this
  }))) : children);
}
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    width: (0, _reduxWindow.getWidth)(state)
  };
})((0, _glamorous.withTheme)(PanelWhiteAside));